<template>
	<div class="tw-flex next-button" :class="{ 'disabled': disabled }">
		<v-btn
			@click="$emit('nextClick')"
			class="custom-button custom-button-icon tw-mr-3" color="primary"
			:disabled="disabled"
		>
			<v-icon>navigate_next</v-icon>
		</v-btn>
		<div class="tw-flex tw-items-center">
			<div class='tw-ml-2'>
				<p>Siguiente</p>
				<p v-if="subTitle"><b>{{ subTitle }}</b></p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'guideline-job-selector-next-button',
	props: ['disabled', 'subTitle'],
};
</script>

<style lang='scss' scoped>
.next-button {
	p {
		color: var(--app-color-primary);
		font-size: 12px;
		margin: 0;
		line-height: 12px;
	}
	&.disabled {
		p {
			color: #969696;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/job-info-edition/guideline-job-selector-next-button.vue